import { useMutation, UseMutationResult } from '@tanstack/react-query';

import { HoldingAvailability } from '@app/components';
import {
  HoldActionErrorDto,
  PlaceHoldDto,
  useFeatureFlag,
  usePatronSession,
} from '@app/hooks';
import { makeRequest, removeEmptyKeys } from '@app/utils';
import { Feature } from '@app/constants';

interface PlaceHoldRequestProps {
  instanceId: string;
  pickupLocationId: string;
  item?: HoldingAvailability;
  patronComments?: string;
}

export const usePlaceHoldMutation = (): UseMutationResult<
  PlaceHoldDto,
  HoldActionErrorDto,
  PlaceHoldRequestProps
> => {
  const { externalSystemId } = usePatronSession();
  const { isActive: isConsortiaLogin } = useFeatureFlag({
    name: Feature.consortiaLoginFlow,
  });

  return useMutation(
    ({
      instanceId,
      pickupLocationId,
      item,
      patronComments,
    }: PlaceHoldRequestProps) => {
      const patronPath = `/opac-patron/account/${externalSystemId}`;
      const holdPath = item?.id
        ? `/item/${item?.id}/hold`
        : `/instance/${instanceId}/hold`;

      const payload = removeEmptyKeys({
        pickupLocationId,
        patronComments,
        ...(item &&
          isConsortiaLogin && {
            instanceId,
            itemAgencyCode: item.library?.code,
            itemLocalSystemCode: item.institution,
          }),
      });

      return makeRequest<PlaceHoldDto>({
        url: `${patronPath}${holdPath}`,
        method: 'POST',
        data: payload,
        withCredentials: isConsortiaLogin,
      });
    }
  );
};
